import "./LinkedinConnectionProgressBar.scss"

import React from "react"
import ProgressBar from "react-bootstrap/ProgressBar"

const LinkedinConnectionProgressBar = ({ status }) => {
  return (
    <div className="linkedin-connection-progress-bar">
      <ProgressBar className="progress-bar" variant="statuses-progress" now={status.percentage} />
    </div>
  )
}

// LinkedinConnectionProgressBar.propTypes = {
//   status: PropTypes.shape({
//     image: PropTypes.string.isRequired,
//     text: PropTypes.string.isRequired,
//     button: PropTypes.instanceOf(Object),
//     input: PropTypes.bool,
//     inputField: PropTypes.bool,
//     progressBar: PropTypes.number.isRequired,
//     tooltip: PropTypes.shape({
//       tooltipText: PropTypes.string.isRequired,
//       tooltipTop: PropTypes.string.isRequired,
//       tooltipLeft: PropTypes.string.isRequired,
//     }),
//   }).isRequired,
// }

export default LinkedinConnectionProgressBar
